import { Fragment } from "react";
import {
	Menu,
	Transition,
	MenuItems,
	MenuItem,
	MenuButton,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";

interface MenuListProps {
	buttonLabel: string;
	menuOptions?: any[];
	onChange: (menuOption: any) => void;
}

export default function MenuList(Props: MenuListProps) {
	const { buttonLabel, menuOptions, onChange } = Props;

	return (
		<Menu as="div" className="absolute inline-block">
			<div>
				<MenuButton className="flex gap-x-1.5 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm">
					{({ open }) => (
						<>
							{buttonLabel}
							{open ? (
								<ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
							) : (
								<ChevronUpIcon className="h-5 w-5" aria-hidden="true" />
							)}
						</>
					)}
				</MenuButton>
			</div>

			<Transition
				as={Fragment}
				enter="transition ease-out duration-100"
				enterFrom="transform opacity-0 scale-95"
				enterTo="transform opacity-100 scale-100"
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95"
			>
				<MenuItems className="absolute left-0 z-10 mt-0 w-auto min-w-28 origin-top-right shadow-lg bg-primary bg-opacity-10">
					<div className="py-1">
						{(menuOptions || []).map((menuOption, index) => (
							<MenuItem key={index}>
								{({ focus }) => (
									<a
										onClick={() => onChange && onChange(menuOption)}
										className={clsx(
											focus
												? "bg-primary bg-opacity-30 text-[1.1rem]"
												: "text-bold text-[1.1rem]",
											"block px-4 py-2 text-sm",
										)}
									>
										{menuOption}
									</a>
								)}
							</MenuItem>
						))}
					</div>
				</MenuItems>
			</Transition>
		</Menu>
	);
}
